<template>
    <section
        class="cta section center-content"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                style="border-radius: 4px"
                class="cta-inner section-inner reveal-scale-down"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider',
                    split && 'cta-split'
                ]">
                <div class="cta-slogan">
                    <div class="container-xs">
                        <h2 class="mt-0 mb-8">
                            Ready to ditch Print Screen?
                        </h2>
                        <p class="m-0">
                            Spend a few minutes learning Pixtel and start building better screenshots without even trying.
                        </p>
                    </div>
                </div>
                <div class="cta-action">
                    <c-button @click="openEmailModal" color="secondary" wide-mobile>
                        Download for Windows
                    </c-button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js'
import CButton from '@/components/elements/Button.vue'

export default {
  name: 'CCta',
  components: {
    CButton
  },
  mixins: [SectionProps],
  props: {
    split: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openEmailModal() {
        document.getElementById("download").click();
    },
  }
}
</script>